module.exports = __webpack_public_path__ + "img/logoY.17b6c0d8.png";